var React = require('react');

function FbMessenger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,7.4c0,2.3,1.1,4.4,3,5.7V16l2.7-1.5c0.8,0.2,1.5,0.3,2.3,0.3c4.4,0,8-3.3,8-7.4S12.4,0,8,0S0,3.3,0,7.4L0,7.4z M7.2,5.3\n\tl2.1,2.2l3.9-2.2L8.8,10L6.7,7.8l-4,2.2L7.2,5.3z","fill":"currentColor"}));
}

FbMessenger.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = FbMessenger;

FbMessenger.default = FbMessenger;
